import { Box, Text, Link } from '@chakra-ui/react';
import React from 'react';
import { localise } from '../../../../../services/lang/lang';
import useAssignInspectorsFormField from './useAssignInspectorsFormField';
export const AssignedInspectorAssignToMe = (props) => {
    const { onAssignToMe, onAssignKeyDown } = useAssignInspectorsFormField(props.onChange, undefined);
    return (React.createElement(Box, null,
        React.createElement(Link, { onClick: onAssignToMe, onKeyDown: onAssignKeyDown, textDecoration: "none", "data-testid": "assign_inspector__assign-to-me" },
            React.createElement(Text, { tabIndex: 0, variant: "link-400-lk-3" }, localise('ASSIGN_TO_ME')))));
};
